// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"f133a69c","198":"94b3c9ec","498":"7fa140ec","550":"00e4a661","587":"60ec44d0","703":"a2e72f67","802":"ad557d93"}[chunkId] + ".chunk.js";
};